// eslint-disable-next-line
import React, { Component } from 'react';
import QrReader from 'react-qr-reader'
import { deviceDetect } from 'react-device-detect'
import TitleBar from '../TitleBar'
import getLabel from '../../utilities/label.js'
import './scanner.css'
import Cookies from 'universal-cookie'
import { confirmAlert } from 'react-confirm-alert'
import _ from 'lodash'

export default class Scanner extends Component {
  constructor(props){
    super(props)
    const agent = deviceDetect(window.navigator.userAgent)
    const device = agent?.osName?.concat(' ')?.concat(agent?.osVersion)
    const browser = agent?.browserName?.concat(' ')?.concat(agent?.browserFullVersion)
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.state = {
      device: device,
      browser: browser,
      delay: 3000,
      result: 'No result',
      backButton: backButton,
      canScan: false
    }
    this.handleScan = this.handleScan.bind(this)
    this.goBack = this.goBack.bind(this)
    this.props.setActiveTab('attendees')
    this.cookies = new Cookies()
    window.trackPage('BizCardScannerScreen')
  }

  componentDidMount(){
    this.handleCanScan()
  }

  handleScanAgreement() {
    this.setState({
      canScan: true
    })
    this.cookies.set('scanner_agreement', 'true')
  }

  scannerAgreement(){
    if(_.isEmpty(this.cookies) || this.cookies.get('scanner_agreement') !== 'true') {
      confirmAlert({
        title: 'Virtual Business Card Exchange',
        message: getLabel('scanner_instructions'),
        buttons: [
          {
            label: 'Cancel',
            onClick: () => window.history.back(),
          },
          { label: 'Continue',
            onClick: () => { this.handleScanAgreement() },
            className: 'solar-button'
          }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
      })
    } else {
      this.setState({
        canScan: true
      })
    }
  }

  handleCanScan(){
    if(this.state.device.includes('iOS')){
      if(window.navigator.userAgent.includes('EdgiOS') || !this.state.browser.includes('Mobile Safari')){ // need to catch MS Edge first, Edgi
        this.setState({
          canScan: false
        })
        confirmAlert({
          title: 'Error',
          message: 'This feature is not available on this browser. Please open this page in a Safari browser window and try again.',
          buttons: [
            {
              label: 'OK',
              onClick: () => window.history.back(),
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        })
      } else {
        this.scannerAgreement()
      }
    } else {
      this.scannerAgreement()
    }
  }

  handleScan(qrCode){
    if(qrCode){
      var data = { business_card_hash: qrCode }
      this.props.postResource({ key: 'user_business_card', data: data, callback: (message, status) => {
        if(status === 201) {
          let user = _.find(this.props.users.event_users, {user_id: message.user_business_card.recipient_user.id})
          if(user) {
            this.props.flashMessage({ message: getLabel('biz_card_success'), type: 'success' })
            this.goBack()
            return
          } else {
            this.props.flashMessage({ message: `${getLabel('biz_card_success')}. Note: you might need to refresh your attendee list.`, type: 'success' })
            this.goBack()
            return
          }
        } else {
          this.props.flashMessage({ message: message, type: 'warning' })
          this.goBack()
          return
        }
      }})
    }
  }

  handleError(err){
    console.error(err)
  }

  goBack() {
    this.props.getResource({
      key: 'users',
      update: true,
      callback: () => window.history.back()
    })
  }

  render(){
    var React = require('react')
    var QRCode = require('qrcode.react')
    return(
      <div className='scannerPage'>
        <TitleBar
          title={ getLabel('business_card_exchange') }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ this.goBack }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        { this.state.canScan === true ? (
          <p className="blue-header center bold">{getLabel('scanner_helper_text')}</p>
        ) : (
          <p className="blue-header center bold">Have someone use the EvantaEvents app to scan your QR/bar code to exchange business cards.</p>
        )}
        { this.state.canScan &&
          <QrReader
            delay={this.state.delay}
            onError={this.handleError}
            onScan={this.handleScan}
            style={{ minWidth: '340px', width: '50%', marginRight: 'auto', marginLeft: 'auto' }} />
        }
        <div className="qr-code">
          <p>{getLabel('my_qr_code')}</p>
          <div>
            <QRCode value={window.currentUser.business_card_hash} />
          </div>
        </div>
      </div>
    )
  }
}
